import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { path: '/', label: 'Inicio' },
  { path: '/servicios', label: 'Servicios' },
  { path: '/equipo', label: 'Equipo' },
  { path: '/contacto', label: 'Contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className={`font-display text-2xl tracking-tight transition-colors duration-500 ${scrolled ? 'text-teal-900' : 'text-white'}`}>
          Serenidad
        </Link>
        {/* Desktop */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <Link
              key={l.path}
              to={l.path}
              className={`text-sm tracking-wide transition-colors duration-200 ${
                scrolled
                  ? pathname === l.path ? 'text-teal-700 font-medium' : 'text-stone-600 hover:text-teal-700'
                  : pathname === l.path ? 'text-white font-medium' : 'text-white/80 hover:text-white'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contacto" className="btn-primary text-xs py-2 px-5">
            Agendar cita
          </Link>
        </nav>
        {/* Mobile toggle */}
        <button className={`md:hidden transition-colors duration-500 ${scrolled ? 'text-stone-700' : 'text-white'}`} onClick={() => setOpen(!open)}>
          <span className="text-2xl">{open ? '✕' : '☰'}</span>
        </button>
      </div>
      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {links.map(l => (
            <Link key={l.path} to={l.path} className="text-stone-700 text-sm" onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}